export default "__VITE_ASSET__f0ebc95b__"